










































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import { GruposResultadosExamesForm, ResultadoDeExameFormItem, TipoParto } from '../../../../back/src/types';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import { tipoPartoStrings } from '../../utils/constants';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { Gestacao } from '../../../../back/src/entity/Gestacao';

export default Vue.extend({
  name: 'ResultadosDeExamesRevisar',
  components: {
    IfEmptyTextPrintNA,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
      required: true,
    },
    gestacao: {
      type: Object as () => Gestacao,
      required: true,
    },
    dataExame: {
      type: String,
      required: true,
    },
    gruposResultados: {
      type: Array as () => GruposResultadosExamesForm[],
      required: true,
    },
    resultadosExtras: {
      type: Array as () => ResultadoDeExameFormItem[],
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          value: 'grupo',
          text: 'Grupo ',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'exame',
          text: 'Exame ',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'resultado',
          text: 'Resultado ',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'status',
          text: 'Status ',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'observacoes',
          text: 'Observações ',
          class: 'text-no-wrap',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    itemsRevisar(): {
      grupo: string,
      exame: string | null,
      status: string | null,
      classStatus: string,
      resultado: string,
      observacoes: string | null,
    }[] {
      const items = [] as {
        grupo: string,
        exame: string | null,
        status: string | null,
        classStatus: string,
        resultado: string,
        observacoes: string | null,
      }[];
      _.forEach(
        this.gruposResultados as GruposResultadosExamesForm[],
        (grupoResultados) => {
          _.forEach(
            grupoResultados.resultadosDeExamesItems as ResultadoDeExameFormItem[],
            (item) => {
              if (item.resultado || item.status) {
                items.push({
                  grupo: grupoResultados.grupoExameNome,
                  exame: item.exameLabel,
                  status: item.status,
                  classStatus: this.getClassStatus(item.opcoesStatus, item.status),
                  resultado: item.resultado,
                  observacoes: item.observacoes,
                });
              }
            },
          );
        },
      );
      _.forEach(
        this.resultadosExtras as ResultadoDeExameFormItem[],
        (item) => {
          if (item.nomeExame) {
            items.push({
              grupo: '',
              exame: item.nomeExame,
              status: item.status,
              classStatus: this.getClassStatus(item.opcoesStatus, item.status),
              resultado: item.resultado,
              observacoes: item.observacoes,
            });
          }
        },
      );
      return items;
    },
    tituloGestacao(): string {
      if (!this.gestacao) {
        return 'Sem gestação associada';
      }
      if (this.paciente.gestacao_atual && this.paciente.gestacao_atual.id === this.gestacao.id) {
        return 'Gestação atual';
      }
      const momentDataParto = moment(this.gestacao.data_parto);
      const dataParto = momentDataParto.isValid() ? momentDataParto.format('DD/MM/YYYY') : '';
      const tipoParto = _.has(tipoPartoStrings, this.gestacao.tipo_parto)
        ? ` - ${tipoPartoStrings[this.gestacao.tipo_parto]}`
        : '';
      let nomeBebes = '';
      if (this.gestacao.tipo_parto === TipoParto.N || this.gestacao.tipo_parto === TipoParto.C) {
        nomeBebes = ` - ${this.gestacao.nome1}${this.gestacao.nome2 ? ` & ${this.gestacao.nome2}` : ''}`;
      }
      return `Gestação anterior (${dataParto}${tipoParto}${nomeBebes})`;
    },
    dataExameFormatada(): string {
      if (this.dataExame) {
        const momentData = moment(this.dataExame);
        if (momentData.isValid()) {
          return momentData.format('DD/MM/YYYY');
        }
      }
      return '';
    },
  },
  methods: {
    getClassStatus(opcoesStatus: { value: string, text: string, color: string }[], status: string) {
      const opcaoStatus = _.find(opcoesStatus, opcao => (opcao.value === status));
      if (opcaoStatus) {
        return `${opcaoStatus.color}--text font-weight-medium`;
      }
      return '';
    },
  },
});
